import axios from 'axios';

export default {
    get(page) {
        var options = {
            method:'GET',
            url: window.apiUrl + '/text-components?page=' + page,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response.data;        
        }).catch((e) =>{
            console.log(e);
            throw new Error(e);
        })
    },

}


// WEBPACK FOOTER //
// ./src/services/cms/index.js